import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpWeedfreeService } from 'src/app/services/http-weedfree.service';

@Component({
  selector: 'app-client-document-list',
  templateUrl: './client-document-list.component.html',
  styleUrls: ['./client-document-list.component.scss']
})
export class ClientDocumentListComponent implements OnInit {

  public documents: string[];
  public client: number = 0;

  constructor(
    private route: ActivatedRoute,
    private http: HttpWeedfreeService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.client = params['client'];
    });

    this.route.data.subscribe(data => {
      this.documents = data.documents;
    })
  }

  onDelete(document: string) {
    this.http.deleteClientDocument(this.client, document).subscribe(
      success => {
        const index = this.documents.indexOf(document);
        this.documents.splice(index, 1);
      }
    )
  }

  onFileUploaded(newDocument: string) {
    this.documents.push(newDocument);
  }

}
